export enum BasicsConstance {
  USER_TOKEN = 'token',
  USER_ID = 'id',
  COMPANY_LINK = 'companyLink',
  COMPANY_CODE = 'companyCode',
  LANG = 'language',
  AR = 'العربية',
  EN = 'English',
}
